import React from 'react'
import Chip from '@mui/material/Chip'
import { Tooltip, Zoom } from '@mui/material'

interface ComponentProps {
  orderType: string | undefined
}

export const OrderTypeChip: React.FC<ComponentProps> = ({ orderType }: ComponentProps) => {
  let variant: 'outlined' | undefined
  let color: 'primary' | 'warning' | 'error' | 'secondary' | 'success' | undefined

  if (orderType === 'FREE_CELL') {
    color = 'secondary'
    variant = 'outlined'
  } else {
    variant = 'outlined'
  }

  return (
    <>
      {orderType === undefined
        ? (
          <></>
          )
        : (
          <Tooltip title={orderType} TransitionComponent={Zoom} arrow placement='bottom'>
            <Chip label={orderType} variant={variant} color={color} />
          </Tooltip>
          )
      }
    </>
  )
}
